<template>
  <v-snackbar v-model="snackbar.isOn">
    <div>{{ snackbar.message }}</div>
    <template v-slot:action="{attrs}">
      <v-btn color="orange" text v-bind="attrs" @click="snackbar.isOn = false">
        {{ snackbar.cta }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      snackbar: {
        isOn: null,
        message: 'test',
        cta: 'Okay',
      },
    }
  },
  computed: {
    snackbarData() {
      return this.$store.getters['Snackbar/snackbarData']
    },
  },
  watch: {
    snackbarData() {
      this.snackbar = this.snackbarData
    },
    snackbar: {
      deep: true,
      handler() {
        this.$store.dispatch('Snackbar/updateSnackbar', this.snackbar)
      },
    },
  },
  created() {
    this.snackbar.isOn = this.snackbarData.isOn
  },
}
</script>

<style></style>
